import { render, staticRenderFns } from "./MultiRights.vue?vue&type=template&id=b8a50fc8"
import script from "./MultiRights.vue?vue&type=script&lang=js"
export * from "./MultiRights.vue?vue&type=script&lang=js"
import style0 from "./MultiRights.vue?vue&type=style&index=0&id=b8a50fc8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports